import React from "react";
import { Link } from "react-router-dom";
import { BOOKS } from "../data/site";
import { ArrowRight, BookOpen } from "lucide-react";

export default function Books() {
  return (
    <div data-testid="books-page">
      <header className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-12 md:pb-16">
        <p className="label mb-4">Children's Literature</p>
        <h1 className="serif text-5xl md:text-7xl tracking-tight font-light leading-[1.02]">
          Books.
        </h1>
        <p className="mt-6 max-w-2xl text-[hsl(var(--ink-soft))] text-lg leading-relaxed">
          Picture books written and illustrated by Joseph — stories for the
          next generation of artists, cowboys, and storytellers.
        </p>
      </header>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pb-32 space-y-20 md:space-y-28">
        {BOOKS.map((b, i) => (
          <article
            key={b.id}
            className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center"
            data-testid={`book-${b.id}`}
          >
            <figure
              className={`md:col-span-5 ${
                i % 2 === 0 ? "md:order-1" : "md:order-2"
              }`}
            >
              <div className="aspect-square overflow-hidden bg-[hsl(var(--surface))] shadow-2xl shadow-black/10">
                {b.cover ? (
                  <img
                    src={b.cover}
                    alt={`${b.title} — book cover`}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full flex flex-col items-center justify-center text-[hsl(var(--ink-soft))] gap-3">
                    <BookOpen className="h-10 w-10" />
                    <p className="label">Cover image forthcoming</p>
                  </div>
                )}
              </div>
            </figure>

            <div
              className={`md:col-span-7 ${
                i % 2 === 0 ? "md:order-2" : "md:order-1"
              }`}
            >
              {b.badge && (
                <span className="inline-block bg-[hsl(var(--accent))] text-background px-3 py-1 text-[0.625rem] uppercase tracking-[0.18em] mb-5">
                  {b.badge}
                </span>
              )}
              <p className="label mb-3">
                Picture Book · {b.year}
                {b.format ? ` · ${b.format}` : ""}
              </p>
              <h2 className="serif text-4xl md:text-6xl tracking-tight font-light leading-[1.05]">
                {b.title}
              </h2>
              <p className="serif italic text-lg text-[hsl(var(--ink-soft))] mt-3">
                {b.role}
              </p>
              <p className="mt-8 text-[hsl(var(--ink-soft))] leading-relaxed text-lg max-w-xl">
                {b.blurb}
              </p>
              {b.link && (
                <a
                  href={b.link}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-8 inline-flex items-center gap-3 bg-foreground text-background px-7 py-3.5 text-xs uppercase tracking-[0.18em] hover:opacity-90"
                  data-testid={`book-buy-${b.id}`}
                >
                  {b.link.includes("gravescollective") ? "Purchase at Graves Collective" : "Purchase · Secure Square Checkout"}
                  <ArrowRight className="h-3.5 w-3.5" />
                </a>
              )}
            </div>
          </article>
        ))}

        <section className="border-t border-border pt-16 md:pt-24 text-center">
          <p className="label mb-4">School Visits & Reading Events</p>
          <h2 className="serif text-4xl md:text-5xl tracking-tight font-light">
            Bring Joseph to your classroom.
          </h2>
          <p className="mt-6 max-w-xl mx-auto text-[hsl(var(--ink-soft))] leading-relaxed">
            Joseph offers school visits, library readings, and writing
            workshops for K–8 audiences across the Front Range.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link
              to="/contact"
              className="bg-foreground text-background px-8 py-4 text-xs uppercase tracking-[0.18em]"
              data-testid="books-contact-cta"
            >
              Book a reading
            </Link>
            <Link
              to="/services"
              className="border border-foreground px-8 py-4 text-xs uppercase tracking-[0.18em] hover:bg-foreground hover:text-background transition-colors"
            >
              Studio services
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}
